<template>
  <header class="home-section-header">
    <p v-if="eyebrow" class="home-section-eyebrow">{{ eyebrow }}</p>
    <h2 class="home-section-title">{{ title }}</h2>
    <p v-if="subtitle" class="home-section-subtitle">{{ subtitle }}</p>
  </header>
</template>

<script>
export default {
  name: "HomeSectionHeader",
  props: {
    title: { type: String, required: true },
    subtitle: { type: String, default: "" },
    eyebrow: { type: String, default: "" },
  },
};
</script>
